export default {
  isDev: process.env.NODE_ENV === 'development',
  reduxLogging: process.env.NODE_ENV === 'development',
  useReactotron: process.env.NODE_ENV === 'development'
}



// WEBPACK FOOTER //
// ./src/Config/DebugConfig.js